import {ComponentProps, forwardRef, useEffect} from 'react';
import {ChoiceProps} from '@/hooks/types';
import useCheckList from '@/hooks/useCheckList';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuTrigger,
} from '@/shadcn_components/ui/dropdown-menu';
import {Button} from '@/shadcn_components/ui/button';
import Chip from './Chip';
import {ScrollArea} from '@/shadcn_components/ui/scroll-area';

export type SelectMultipleProps = Omit<ComponentProps<'input'>, 'ref'> & {
  choices: ChoiceProps[];
  optionId?: string;
  optionText?: string;
  placeHolder?: string;
  value?: ChoiceProps[];
  onChange?: (selectedItems: ChoiceProps[]) => void;
};

const SelectMultiple = (props: SelectMultipleProps, ref) => {
  const {choices, placeHolder, value, optionId = 'id', optionText = 'label', onChange} = props;

  const {setSelectedItems, selectedItems, isSelected, toggleItemSelectState} = useCheckList();

  // update selectedItems when value changed
  useEffect(() => {
    const list = (choices || []).filter(ch =>
      (value || []).find(v => String(v.id) === String(ch.id)),
    );
    setSelectedItems(list);
  }, [value, choices]);

  return (
    <DropdownMenu>
      <div className="flex flex-row gap-1 flex-wrap">
        <DropdownMenuTrigger asChild>
          <Button type="button" size="sm" variant="outline" className='border-primary'>
            {placeHolder}
          </Button>
        </DropdownMenuTrigger>
        {selectedItems.map((v, i) => (
          <Chip
            key={i}
            value={v[optionText]}
            onClose={() => {
              const list = toggleItemSelectState(v);
              onChange?.(list);
            }}
          />
        ))}
      </div>
      <DropdownMenuContent>
        <ScrollArea className="max-h-72">
          {choices.map((v, i) => (
            <DropdownMenuCheckboxItem
              onSelect={event => event.preventDefault()}
              key={i}
              checked={isSelected(v)}
              onCheckedChange={checked => {
                const list = toggleItemSelectState(v, checked);
                onChange?.(list);
              }}>
              {v[optionText]}
            </DropdownMenuCheckboxItem>
          ))}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default forwardRef(SelectMultiple);
